<template lang="pug">
v-card(outlined)
  v-card-title Настройки почты
    .ml-auto
      v-btn.rounded.mr-4(small @click="checkConnectEmail") Проверить соединение с почтой
      v-btn.rounded(@click="show = !show"  fab small)
        v-icon mdi-cog

  v-alert.ma-0(
    v-if="user.email_setting"
    tile
    text
    color="success"
  )
    .d-flex.align-center
      span.mr-2 Вы уже настроили почту {{ user.email_setting.username }}
      v-tooltip(bottom) Удалить почту
        template(#activator="{ on }")
          v-btn.ml-auto.rounded(
            @click="deleteEmailSettings"
            v-on="on"
            fab
            small
            color="error"
          )
            v-icon mdi-close
  v-expand-transition(v-else)
    v-card-text(v-if="show")
      v-form(v-model="valid")
        template(v-if="!user.parent_id")
          v-text-field(
            v-model="form.name"
            filled
            label="Отображение от кого письмо"
            hide-detials="auto"
          )
          v-text-field(
            v-model="form.username"
            filled
            label="Почта"
            hide-detials="auto"
          )
          v-select(
            v-model="form.email_protocol_id"
            label="Тип почты"
            item-value="id"
            item-text="title"
            :items="email_protocols"
            :rules="[rules.required]"
            filled
          )
          password-input(
            v-model="form.password"
            filled
            label="Пароль от почты"
            hide-detials="auto"
            :rules="[rules.min(5)]"
          )
          password-input(
            v-model="form.password_confirmation"
            filled
            label="Подтверждение пароля"
            hide-detials="auto"
            :rules="[rules.same(form.password)]"
          )
      v-btn(
        :loading="loadingUpdate"
        :disabled="!valid"
        @click="updateEmailSettings"
        color="primary"
      ) Обновить
</template>

<script>
import { CRUDEmailProtocol } from '@/services/API/email-protocol';
import { mapGetters, mapMutations } from 'vuex';
import rules from '@/lib/rules';
import userService from '@/services/API/user';
import PasswordInput from '@/components/inputs/PasswordInput.vue';
import emailSettingsService from '@/services/API/email-settings';

export default {
  components:{
    PasswordInput,
  },
  data() {
    return {
      valid:false,

      show: true,

      loadingUpdate:false,

      form: {
        'email_protocol_id': null,
        'name': '',
        'username': '',
        'password': '',
        'password_confirmation': '',
      },

      email_protocols: [],
      rules,
    };
  },
  computed: {
    ...mapGetters({
      'userRole': 'auth/userRole',
      'user':'auth/getUser',
    }),
  },

  created() {
    this.fetchEmailProtocol();
  },

  methods: {
    ...mapMutations({
      'setUser':'auth/SET_USER',
    }),
    async updateProfile() {
      try {
        this.loadingUpdate = true;
        const response = await userService.updateProfile(this.user.id, this.form);
        this.setUser(response.data.data);
        this.$toast.success('Профиль успешно обновлен');
      } finally {
        this.loadingUpdate = false;
      }
    },
    async checkConnectEmail() {
      if (this.user.email_setting) {
        try {
          const response = await emailSettingsService.checkConnectEmail(this.user.email_setting.id);
          if (response.data.data.is_active) this.$toast.success('Ваша почта подключена');
          else this.$toast.warning('Ваша почта не подключена');
        } catch (e) {
          this.$toast.error(e.response.data.result_message);
        }
      } else {
        this.$toast.warning('Отсутствует информация о настройках почты(email_settings - null)');
      }
    },
    async deleteEmailSettings() {
      try {
        this.loadingUpdate = true;
        await emailSettingsService.delete(this.user.email_setting.id);
        this.setUser({ ...this.user, email_setting:null });
      } catch (error) {
        this.$toast.error(error.response.data.data.message);
      } finally {
        this.loadingUpdate = false;
      }
    },

    async updateEmailSettings() {
      try {
        this.loadingUpdate = true;
        const response = await emailSettingsService.create({ ...this.form, user_id: this.user.id });
        this.setUser({ ...this.user, email_setting:response.data.data });
      } catch (error) {
        this.$toast.error(error.response.data.data.message);
      } finally {
        this.loadingUpdate = false;
      }
    },
    async fetchEmailProtocol() {
      const response = await CRUDEmailProtocol.getAll();
      this.email_protocols = response.data.data;
    },

  },
};
</script>

<style></style>
